import { Navigate, Route, Routes } from 'react-router-dom';
import smoothScrollPolyfill from 'smoothscroll-polyfill';

import { LandingPage } from '@/pages/LandingPage';
import { IpRestrictedPage } from '@/pages/IpRestricted';

smoothScrollPolyfill.polyfill();

function Landing() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/ip-restricted" element={<IpRestrictedPage />} />
      <Route path="*" element={<Navigate replace to="/" />} />
    </Routes>
  );
}

export { Landing };
